$(document).ready(function(){

	var cookiesConsent = Cookies.get('cookies_consent');
	if (cookiesConsent === undefined || cookiesConsent === 'undefined') {
		showCookies();
	} else {
		hideCookies();
	}
	
	if (cookiesConsent == 'allow') {
		var trackingID = $('.allow__cookies').attr('data-ga');
		if (typeof(trackingID) !== 'undefined' && trackingID != '') {
			var trackingCode = '<!-- Global site tag (gtag.js) - Google Analytics --><script async src="https://www.googletagmanager.com/gtag/js?id='+ trackingID +'"></script><script>window.dataLayer=window.dataLayer || []; function gtag(){dataLayer.push(arguments);}gtag("js", new Date()); gtag("config", "'+ trackingID +'");</script>';
			$('body').append(trackingCode);
		}
	}

	$('.deny__cookies').on('click', function(){
		Cookies.set('cookies_consent','deny',{expires: 30});
		hideCookies();
	});

	$('.allow__cookies').on('click', function(){
		Cookies.set('cookies_consent','allow',{expires: 30});
		hideCookies();
	});


	function showCookies(){
		$('.cookies__consent').css({'transform': 'translateY(0)'});
	}

	function hideCookies(){
		$('.cookies__consent').css({'transform': 'translateY(10rem)'});
	}
	
});